import {store} from "../store";
import {router} from "../router";
import {message} from "@/shared/message";
import NProgress from 'nprogress';

export function errorResponseHandler(error) {
  console.log(error);
  console.log(error.response);
  NProgress.done();
  if (error.response) {
    //toast.error(error.response.data.message);
    //localStorage.removeItem("user");
    //axios.defaults.headers.common["Authorization"] = null;
    if (error.response.status == 500) {
      //alert("Internal Server Error");
      //store.commit("auth/logout");
      //router.push("/login");
      //alert(error.response.data.message);
    }
    if (error.response.status == 403) {
      
      if(error.response.data == "")
        message.error("Credential invalid. Please login again");
      //router.push("/login");
      //message.error("Credential invalid. Please login again");
      //message.error("Enter a valid username and password!");
      //return;
    }
    if (error.response.status == 401) {
      // if(error.response.data == "token_expired"){
        message.error("Credential invalid or session expired");
        store.commit("auth/logout");
        router.push("/login");
      // }else{
      //   message.error("Credential invalid. Please login again");
      // }
      //alert("Credential invalid. Please login again");
    }

    //alert('Error Response:'+error.response.data.message);
  }
  //debugger;
  return Promise.reject(error.response);
  //   if (
  //     error.config.hasOwnProperty("errorHandle") &&
  //     error.config.errorHandle === false
  //   ) {
  //       console.log('here');
  //     return Promise.reject(error);
  //   }
}

export function successResponseHandler(response) {
  store.commit("common/setLoading", false);
  //console.log("stop loading");
    NProgress.done();
  
  if (response) {
    //console.log(response);
    if (response && response.status === 401) {
      // auto logout if 401 response returned from api
      location.reload(true);
    }
    return response.data;
  }
}

export function requestHandler(config) {
  store.commit("common/setLoading", true);
  NProgress.start();
  //console.log("loading");
  return config;
}
